import React from 'react';
import {
    GenericModal,
    ParetoLogo,
    Input,
    Button,
    MainTheme,
} from '@paretogroup/tess';
import { useSaveModal } from './save-modal.hooks';
import * as S from './save-modal.styles';
import {
    BACKGROUND_IMAGE,
    SAVE_MODAL_AUTO_TEST_IDS,
    SAVE_MODAL_TEST_IDS,
    TEXTS,
} from './save-modal.constants';
import { BACKGROUND_GRADIENT } from './save-modal.styles';
import { CAMPAIGNS_FILTER_AUTO_TEST_IDS, CAMPAIGNS_FILTER_TEST_IDS } from '../campaigns-filter.constants';
import { useCampaignFilterInterface } from '../interface';

const Logo = () => <ParetoLogo colors={{ fill: MainTheme.colors.white }} />;

export const SaveModal = () => {
    const classes = S.useStyles();
    const { filterName, setFilterName, isSaveDisabled } = useSaveModal();
    const { isSaveModalOpen, closeSaveModal, saveFilter } = useCampaignFilterInterface();

    return (
        <GenericModal
            logo={<Logo />}
            title={TEXTS.TITLE}
            subtitle={TEXTS.SUBTITLE}
            backgroundImage={BACKGROUND_IMAGE}
            backgroundGradient={BACKGROUND_GRADIENT}
            open={isSaveModalOpen}
            onClose={closeSaveModal}
            data-testid={CAMPAIGNS_FILTER_TEST_IDS.SAVE_MODAL}
            data-data-testid={CAMPAIGNS_FILTER_AUTO_TEST_IDS.SAVE_MODAL}
        >
            <Input
                classes={{ label: classes.label }}
                label={TEXTS.INPUT_LABEL}
                onChange={e => setFilterName(e.target.value)}
                value={filterName}
                fullWidth
                data-testid={SAVE_MODAL_TEST_IDS.INPUT}
                data-auto-testid={SAVE_MODAL_AUTO_TEST_IDS.INPUT}
            />
            <div className={classes.buttonWrapper}>
                <Button
                    className={classes.cancelButton}
                    onClick={closeSaveModal}
                    data-auto-testid={SAVE_MODAL_AUTO_TEST_IDS.CANCEL_BUTON}
                >
                    {TEXTS.CANCEL_BUTTON_LABEL}
                </Button>
                <Button
                    className={classes.saveButton}
                    onClick={() => saveFilter({ filterName })}
                    disabled={isSaveDisabled}
                    data-testid={SAVE_MODAL_TEST_IDS.SAVE_BUTTON}
                    data-auto-testid={SAVE_MODAL_AUTO_TEST_IDS.SAVE_BUTTON}
                >
                    {TEXTS.SAVE_BUTTON_LABEL}
                </Button>
            </div>
        </GenericModal>
    );
};
